import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { API_BASE } from './api';
import { IS_MYWEALTH_APP } from './appVariant';
import { getClientToken } from './auth';

let listenersInstalled = false;
let registrationPromise = null;

const authHeaders = () => {
  const token = getClientToken();
  return token ? { 'X-KG-Client-Authorization': `Bearer ${token}` } : {};
};

async function post(path, body = {}) {
  const token = getClientToken();
  if (!token) throw new Error('Client session is not available.');
  const response = await fetch(`${API_BASE}/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.status !== 'ok') throw new Error(data.message || 'Push notification request failed.');
  return data;
}

export async function initializeMyWealthPush() {
  if (!IS_MYWEALTH_APP || !Capacitor.isNativePlatform() || !getClientToken()) return;
  if (registrationPromise) return registrationPromise;

  registrationPromise = (async () => {
    if (!listenersInstalled) {
      await PushNotifications.addListener('registration', async ({ value }) => {
        try {
          await post('client_push_register.php', {
            fcm_token: value,
            platform: Capacitor.getPlatform(),
            app_variant: 'mywealth',
            app_version: String(process.env.REACT_APP_APP_VERSION || ''),
            device_label: 'MFSetu - MyWealth',
          });
        } catch (e) {
          console.warn('Push token registration failed.');
        }
      });
      await PushNotifications.addListener('registrationError', () => console.warn('FCM registration failed.'));
      await PushNotifications.addListener('pushNotificationActionPerformed', ({ notification }) => {
        const path = notification?.data?.deep_link;
        if (typeof path === 'string' && path.startsWith('/client/')) window.location.assign(path);
        else window.location.assign('/client/dashboard');
      });
      listenersInstalled = true;
    }

    let permission = await PushNotifications.checkPermissions();
    if (permission.receive === 'prompt') permission = await PushNotifications.requestPermissions();
    if (permission.receive !== 'granted') return;
    await PushNotifications.register();
  })().finally(() => { registrationPromise = null; });

  return registrationPromise;
}

export async function unregisterMyWealthPushFromServer() {
  if (!IS_MYWEALTH_APP || !Capacitor.isNativePlatform() || !getClientToken()) return;
  try { await post('client_push_unregister.php', {}); } catch (_) {}
}
